import React, { Component, PropTypes } from 'react'
import Slider from 'react-slick'
import MediaQuery from 'react-responsive'
import UAParser from 'ua-parser-js'
import qs from 'qs'

import 'slick-carousel/slick/slick.scss'
import 'slick-carousel/slick/slick-theme.scss'
import './Home.scss'
import MobileNavBar from 'components/MobileNavBar'
import BookingForm from './components/BookingForm'
import AliadaProfileSkills from 'components/AliadaProfileSkills'
import { analytics } from '@src/services/Analytics'
import AliadaProfileCard from 'components/AliadaProfileCard'
import Step from './components/Step'
import SecurityStep from './components/SecurityStep'
import { SMALL, maxWidth } from 'utils/media-query'

import step1 from './images/paso1.svg'
import step2 from './images/paso2.svg'
import step3 from './images/paso3.svg'
import perks2 from './images/perks2.jpg'
import perks3 from './images/perks3.jpg'
import aliada1 from './images/2745.jpg'
import aliada2 from './images/2772.jpg'
import aliada3 from './images/2744.jpg'
import beAnAliada from './images/beAnAliada.jpg'
import helpButton from './images/help-button.png'
import logoAliada from 'images/logo-dark.png'

import { LogOnMount } from '@amplitude/react-amplitude'

import { convertGoogleMapsPlaceToAddress } from 'utils/google-maps'

const aliadas = [
  {
    'id': 1,
    'firstName': 'Maria Guadalupe',
    'finishedServicesCount': 133,
    'averageRating': 4.9,
    'pricePerHour': 80,
    serviceCost: 240,
    'superaliada': true,
    'profilePicture': {
      'original': aliada1
    },
    'preferences': [
    ],
    'skills': [
      {
        'slug': 'cleaning',
        'name': 'Limpieza'
      },
      {
        'slug': 'cooking',
        'name': 'Cocina'
      },
      {
        'slug': 'laundry',
        'name': 'Lavandería'
      },
      {
        'slug': 'ironing',
        'name': 'Planchado'
      }
    ]
  },
  {
    'id': 9,
    'firstName': 'Erika',
    'biography': null,
    'finishedServicesCount': 377,
    'averageRating': 4.8,
    'pricePerHour': 80,
    serviceCost: 240,
    'superaliada': true,
    'profilePicture': {
      'original': aliada2
    },
    'preferences': [
      {
        slug: 'offices'
      }
    ],
    'skills': [
      {
        'slug': 'cleaning',
        'name': 'Limpieza'
      },
      {
        'slug': 'cooking',
        'name': 'Cocina'
      },
      {
        'slug': 'laundry',
        'name': 'Lavandería'
      },
      {
        'slug': 'ironing',
        'name': 'Planchado'
      }
    ]
  },
  {
    'id': 12,
    'firstName': 'Lesli Nayeli',
    'biography': null,
    'finishedServicesCount': 508,
    'averageRating': 4.8,
    'pricePerHour': 80,
    serviceCost: 240,
    'superaliada': true,
    'profilePicture': {
      'original': aliada3
    },
    'preferences': [
    ],
    'skills': [
      {
        'slug': 'cleaning',
        'name': 'Limpieza'
      },
      {
        'slug': 'cooking',
        'name': 'Cocina'
      },
      {
        'slug': 'laundry',
        'name': 'Lavandería'
      },
      {
        'slug': 'ironing',
        'name': 'Planchado'
      }
    ]
  }
]

class Home extends Component {
  constructor (props) {
    super(props)
    this.handleColoniaSelect = this.handleColoniaSelect.bind(this)
    this.searchLeavesSight = this.searchLeavesSight.bind(this)
    this.searchEntersSight = this.searchEntersSight.bind(this)
    this.scrollSearchToTop = this.scrollSearchToTop.bind(this)
    this._geoSuggest = {
      focus: () => {}
    }
    this.state = {
      isSearchHidden: false
    }
  }

  componentWillMount () {
    if (window.analytics) {
      this.trackHomeViewEvent()
    }
  }

  trackHomeViewEvent () {
    window.analytics.page('Home')
  }

  _collectColoniaSubmitAnalytics (place) {
    const { neighborhood: coloniaName } = convertGoogleMapsPlaceToAddress(place)
    const eventData = { coloniaName }
    analytics.coloniaSubmit(eventData)
  }

  handleColoniaSelect (location) {
    this._collectColoniaSubmitAnalytics(location)
    this.props.update({ location })

    const format = {
      encode: false,
      arrayFormat: 'brackets'
    }

    const querystring = qs.stringify({
      neighborhood: location.label,
      coordinates: {
        latitude: location.location.lat,
        longitude: location.location.lng,
      }
    }, format)

    const baseUrl = process.env.WILLKOMMEN_ROOT;
    window.location.href = `${baseUrl}?${querystring}`;
  }

  searchLeavesSight () {
    this.setState({isSearchHidden: true})
  }

  searchEntersSight () {
    this.setState({isSearchHidden: false})
  }

  matchesMediaQuery (query) {
    return window.matchMedia(query).matches
  }

  scrollSearchToTop () {
    const mediaQuery = maxWidth(SMALL)
    const osName = this.getUserAgentOS()
    try {
      const isExtraSmallScreen = this.matchesMediaQuery(mediaQuery)
      if (isExtraSmallScreen && osName !== 'iOS') {
        const offsetColonia = this._coloniaAutocomplete.offsetTop
        const heightColonia = this._coloniaAutocomplete.clientHeight
        this._homeContent.scrollTop = offsetColonia - heightColonia
      }
    } catch (e) {}
  }

  getUserAgentOS () {
    const parser = new UAParser()
    const os = parser.getOS()
    return os.name
  }

  render () {
    const steps = [
      {
        image: step1,
        number: '1',
        title: 'Descubre tu Aliada ideal',
        description: 'Encuentra personas expertas en limpieza, lavado, planchado y hasta cocina, que se adapten a tu presupuesto.'
      },
      {
        image: step2,
        number: '2',
        title: 'Haz tu reservación',
        description: 'Compara perfiles, lee los comentarios de otros usuarios y paga de manera segura a través de nuestra plataforma.'
      },
      {
        image: step3,
        number: '3',
        title: '¡Vive!',
        description: 'Deja las tareas de tu casa en nuestras manos y dedica tu tiempo a lo que realmente importa.'
      }
    ]

    const perks = [
      {
        image: perks2,
        title: 'Verificación de identidad',
        description: 'Para prestar sus servicios, todas las Aliadas tienen que pasar por exámenes, entrevistas con psicólogos, revisión de antecedentes y validación de identidad y domicilio.'
      },
      {
        image: perks3,
        title: 'Perfil y evaluaciones',
        description: 'Puedes conocer mejor a tu Aliada gracias a los perfiles detallados, las evaluaciones personales y los comentarios de otros clientes.'
      }
    ]

    const {
      loggedIn,
      logout
    } = this.props

    const loginButton = (
      <a
        href={'/login'}
        className='btn btn-default'
        >
        Iniciar Sesión
      </a>
    )

    const logoutButton = (
      <button
        onClick={logout}
        className='btn btn-default'
        >
        Cerrar Sesión
      </button>
    )

    const authButton = loggedIn ? logoutButton : loginButton

    return (
      <div className='Home navbar-screen'>
        <LogOnMount eventType="landing-page-screen" />

        <MobileNavBar
          leftControl={
            <img src={logoAliada} height='25' />
          }
          rightControl={authButton}
          >
          {this.state.isSearchHidden && <div onClick={() => this._geoSuggest.focus()} className='Home-navbarSearch'><span className='icon-search' /> ¿En qué colonia necesitas ayuda?</div>}
        </MobileNavBar>

        <div className='Home OfficesNavBar'>
          <div className='Home OfficesNavBar Link'>
            <a href="https://aliada.mx/oficinas">
              ¿Necesitas un servicio para tu oficina?
            </a>
          </div>
        </div>

        <div
          className='Home-content navbar-screen-content'
          ref={(el) => {
            this._homeContent = el
          }}
          >

          <div className='Home-hero Home-hero--varA'>
            <div className='Home-container'>
              <BookingForm />
            </div>
          </div>

          <div className='Home-beAnAliada' style={{padding: '25px'}}>
            <div className='Home-container' style={{maxWidth: '900px', border: '0px'}}>
              <div className='Home-beAnAliadaImg'>
                <img src={helpButton} />
              </div>
              <div className='Home-beAnAliadaText'>
                <h4>Protocolo de higiene</h4>
                <p>Conoce las medidas que estamos tomando para proteger a toda la comunidad de aliada ante el COVID-19.</p>
                <a href='/higiene'>MÁS INFORMACIÓN</a>
              </div>
            </div>
          </div>

          <div className='Home-howDoesItWorks' id='Home-howDoesItWorks'>
            <h3>¿Cómo funciona?</h3>
            <div className='Home-container'>
              <MediaQuery maxDeviceWidth={768}>
                <Slider
                  dots
                  className='Home-stepsSlider'
                  speed={500}
                  slidesToShow={1}
                  slidesToScroll={1}
                  >
                  {
                    steps.map(props => (
                      <div key={props.number}>
                        <Step {...props} />
                      </div>
                    ))
                  }
                </Slider>
              </MediaQuery>
              <MediaQuery minDeviceWidth={769}>
                <div className='Home-steps'>
                  {
                    steps.map((props, index) => (
                      <Step key={index} {...props} />
                    ))
                  }
                </div>
              </MediaQuery>
            </div>
          </div>
          <MediaQuery minDeviceWidth={769}>
            <div className='Home-bestOf'>
              <div className='Home-container'>
                <h3>Ellas son algunas de las mejores Aliadas</h3>
                <div className='Home-bestOfAliadas'>
                  {
                    aliadas.map(aliada => (
                      <div key={aliada.id} className='Home-bestAliada'>
                        <AliadaProfileCard aliada={aliada} />
                        <AliadaProfileSkills aliada={aliada} label='Habilidades:' />
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </MediaQuery>
          <div className='Home-security'>
            <div className='Home-container'>
              <h3>La manera más segura de limpiar tu casa.</h3>

              <MediaQuery maxDeviceWidth={768}>
                <Slider
                  dots
                  className='Home-securityStepsSlider'
                  speed={500}
                  slidesToShow={1}
                  slidesToScroll={1}
                  >
                  {
                    perks.map((props, index) => (
                      <div key={index}>
                        <SecurityStep {...props} />
                      </div>
                    ))
                  }
                </Slider>
              </MediaQuery>
              <MediaQuery minDeviceWidth={769}>
                <div className='Home-securitySteps'>
                  {
                    perks.map((props, index) => (
                      <SecurityStep {...props} key={index} />
                    ))
                  }
                </div>
              </MediaQuery>
            </div>
          </div>
          <div className='Home-questions'>
            <div className='Home-questionsIcon'>
              <div className='Home-halfContainer'>
                <span className='icon-comment' />
              </div>
            </div>
            <div className='Home-questionsText'>
              <div className='Home-halfContainer'>
                <h4>¿Tienes dudas?</h4>
                <p>Nuestro increíble equipo de atención al cliente está a tu disposición para ayudarte con todo lo que necesites.</p>
                <button onClick={() => Intercom('show')} className='btn btn-lg btn-default btn-block'>Contactar a atención al cliente</button>
              </div>
            </div>
          </div>
          <div className='Home-beAnAliada'>
            <div className='Home-container'>
              <div className='Home-beAnAliadaImg'>
                <img src={beAnAliada} />
              </div>
              <div className='Home-beAnAliadaText'>
                <h4>¿Quieres prestar tus servicios en la plataforma?</h4>
                <p>Regístrate y comienza a trabajar en las zonas y horarios que te convengan y pasa más tiempo con tu familia.</p>
                <a href='https://forms.gle/jCB2wWBEgKrA66367' className='btn btn-lg btn-primary'>Regístrate como Aliada</a>
              </div>
            </div>
          </div>
          <footer className='Home-footer'>
            <MediaQuery minDeviceWidth={769} className='Home-container'>
              <div className='Home-footerLeft'>
                <nav className='Home-links'>
                  <ul>
                    <li>
                      <a href='/faq'>Preguntas Frecuentes</a>
                    </li>
                    <li>
                      <a href='/terminos'>Términos y Condiciones</a>
                    </li>
                    <li>
                      <a href='/higiene'>Política de higiene</a>
                    </li>
                    <li>
                      <a href='/privacidad'>Política de Privacidad</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className='Home-footerRight'>
                <div className='icon-logo' />
                <div className='Home-footerCopyright'>
                  <p>
                    Hecho con <span className='Home-emoji'>❤️</span>por aliada. Ciudad de México.<br />
                    { new Date().getFullYear() }<br />
                    Todos los derechos reservados.
                  </p>
                </div>
              </div>
            </MediaQuery>
            <MediaQuery maxDeviceWidth={768} className='Home-container'>
              <nav className='Home-links'>
                <ul className='list-inline'>
                  <li>
                    <a href='/faq'>Preguntas Frecuentes</a>
                  </li>
                  <li>
                    <a href='/terminos'>Términos y Condiciones</a>
                  </li>
                  <li>
                    <a href='/higiene'>Política de higiene</a>
                  </li>
                  <li>
                    <a href='/privacidad'>Política de Privacidad</a>
                  </li>
                </ul>
              </nav>
              <img src={logoAliada} alt='Aliada' width='95' />
            </MediaQuery>

          </footer>
        </div>
      </div>
    )
  }
}
Home.displayName = 'Home'
Home.propTypes = {
  update: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired
}

export default Home



// WEBPACK FOOTER //
// ./src/screens/App/screens/Home/Home.js